const isEmpty = (value) => {
  if (value instanceof Array) {
    return !(value && value.length > 0);
  } else {
    return !(value && value.toString().trim());
  }
}

const hasValue = (value) => {
  return !isEmpty(value);
}

export {
  isEmpty,
  hasValue
}


// WEBPACK FOOTER //
// ./src/helpers/datatype_helpers.js